var _defs, _path, _rect, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFreccia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.81 47.74",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0089fb;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m19.91,45.46c-.73,0-1.45-.3-1.97-.88L.66,25.14c-.89-1-.89-2.5,0-3.49L17.94,2.21c.96-1.09,2.63-1.19,3.71-.22,1.09.96,1.18,2.63.22,3.71L6.15,23.39l15.73,17.69c.96,1.09.87,2.75-.22,3.71-.5.45-1.13.67-1.75.67Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16.44,
    y: 39.36,
    width: 6.94,
    height: 6.95,
    transform: "translate(-23.43 24.05) rotate(-41.63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.87,6.58c1.45-1.63,1.3-4.13-.33-5.58-1.63-1.45-4.13-1.3-5.58.33-1.45,1.63-1.3,4.13.33,5.58,1.63,1.45,4.13,1.3,5.58-.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreccia);
export default __webpack_public_path__ + "static/media/freccia.b74c3c012fcf78d7a73851ef68a1f45a.svg";
export { ForwardRef as ReactComponent };